<div class="">
     
</div>
<div class="contact-container">
  <h2>Contact Me</h2>
  <!-- <p>&</p> -->
  <h3 class="contact-subtitle">...and make your ideas come true</h3>
  <div class="contact-link-list">
    <a href="https://github.com/koinu1203"
       target="_blank"
       class="contact-link-list-element">
      <img class="icon icon-github"
           [src]="iconPath+'github-4-icon.svg'"
           alt="">
    </a>
    <a href="https://www.linkedin.com/in/danielortizpary/"
       target="_blank"
       class="contact-link-list-element">
      <img class="icon icon-linkedin"
           [src]="iconPath+'linkedin-icon.svg'"
           alt="">
    </a>
    <a href="https://api.whatsapp.com/send?phone=51947638171"
       target="_blank"
       class="contact-link-list-element">
      <img class="icon icon-whatsapp"
           [src]="iconPath+'whatsapp-icon.svg'"
           alt="">
    </a>
    <a href="https://www.instagram.com/i.koinu/"
       target="_blank"
       class="contact-link-list-element">
      <img class="icon icon-instragram"
           [src]="iconPath+'instagram-3-icon.svg'"
           alt="">
    </a>
    <a href="mailto:daniel_ortizpary@hotmail.com"
       target="_blank"
       class="contact-link-list-element">
      <img class="icon icon-correo"
           [src]="iconPath+'correo-icon.svg'"
           alt="">
    </a>
  </div>
  <span class="contact-footer">Portfolio created by Daniel Ortiz Pary, check the code <a
       href="https://github.com/koinu1203/portfolio"
       target="_blank">here</a></span>
</div>

<!-- https://api.whatsapp.com/send?phone=51947638171 -->
